// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}

ion-content {
  flex: 1;
  min-height: 0;
}

ion-content::part(scroll) {
  height: 100%;
}

.chart-section {
  flex-shrink: 0;
}

.chart-section app-bar-chart,
.chart-section app-pie-chart {
  min-height: 260px;
}

@media (min-width: 1024px) {
  .chart-section.has-data {
    flex: 1 1 auto;
    min-height: 0;
  }
  .chart-section app-bar-chart,
  .chart-section app-pie-chart {
    min-height: 0;
  }
}
ion-card {
  margin-inline: 0;
}

::ng-deep app-bar-chart ion-card,
::ng-deep app-pie-chart ion-card {
  --background: var(--ion-card-background);
}`, "",{"version":3,"sources":["webpack://./src/app/dashboard-home/dashboard-home.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAGA;EACE,OAAA;EACA,aAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;;EAEE,iBAAA;AAAF;;AAGA;EACE;IACE,cAAA;IACA,aAAA;EAAF;EAGA;;IAEE,aAAA;EADF;AACF;AAKA;EACE,gBAAA;AAHF;;AAOA;;EAEE,wCAAA;AAJF","sourcesContent":[":host {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n// senza flex:1 ion-content collassa ad altezza auto; h-full interno non funziona\nion-content {\n  flex: 1;\n  min-height: 0;\n}\n\nion-content::part(scroll) {\n  height: 100%;\n}\n\n.chart-section {\n  flex-shrink: 0;\n}\n\n.chart-section app-bar-chart,\n.chart-section app-pie-chart {\n  min-height: 260px;\n}\n\n@media (min-width: 1024px) {\n  .chart-section.has-data {\n    flex: 1 1 auto;\n    min-height: 0;\n  }\n\n  .chart-section app-bar-chart,\n  .chart-section app-pie-chart {\n    min-height: 0;\n  }\n}\n\n// Azzera solo i margini orizzontali di Ionic, lasciando invariati quelli verticali (mb-2 ecc.)\nion-card {\n  margin-inline: 0;\n}\n\n// Override background dei grafici embedded (non raggiungibile via Tailwind)\n::ng-deep app-bar-chart ion-card,\n::ng-deep app-pie-chart ion-card {\n  --background: var(--ion-card-background);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
